import React, { useState } from 'react';
import { Layout } from '../components/Layout';
import { SEO, pageSEO } from '../components/SEO';
import { Card, CardContent } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Handshake, CheckCircle2, Briefcase, Users, Shield, TrendingUp, Building2, Home } from 'lucide-react';
import { sendViaWeb3Forms } from '../services/web3formsService';
export function PartnerPage() {
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    const formData = new FormData(e.target as HTMLFormElement);
    const data = Object.fromEntries(formData.entries()) as Record<string, string>;
    // Envoyer via Web3Forms (email à contact@adcc.africa)
    const result = await sendViaWeb3Forms({
      type: 'partenariat',
      fields: data
    });
    console.log('📋 Partenariat submission result:', result);
    setIsLoading(false);
    setSubmitted(true);
  };
  if (submitted) {
    return <Layout data-id="element-1641" data-mp="1qwhzkk7r3n2o">
        <div className="min-h-[60vh] flex items-center justify-center bg-gray-50 px-4" data-id="element-1642" data-mp="1qwqdmffm0yfg">
          <Card className="max-w-md w-full text-center p-8 shadow-xl border-t-4 border-t-[#1E88E5]" data-id="element-1643" data-mp="25tr7aohd33gk">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-1644" data-mp="20x0s03ddsbw7">
              <CheckCircle2 className="w-10 h-10 text-green-600" data-id="element-1645" data-mp="1d6mvo0nrjqvt" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-1646" data-mp="1883d8a8dox87">
              Demande de partenariat envoyée !
            </h2>
            <p className="text-gray-600 mb-8" data-id="element-1647" data-mp="1my12yulyhuzi">
              Merci de votre confiance. Notre équipe chargée des relations
              employeurs va étudier votre demande et vous recontactera dans les
              plus brefs délais pour échanger sur vos besoins.
            </p>
            <Button onClick={() => window.location.reload()} className="w-full" data-id="element-1648" data-mp="pg10vb2rs33r">
              Fermer
            </Button>
          </Card>
        </div>
      </Layout>;
  }
  return <Layout data-id="element-1649" data-mp="1j588m5geqva0">
      <SEO {...pageSEO.partner} data-id="element-1650" data-mp="1j4qepfh7wt59" />
      {/* Header */}
      <div className="bg-[#2C3E50] text-white py-16 md:py-24" data-id="element-1651" data-mp="1nwhtksr0hafk">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1652" data-mp="1nz2xroes82gh">
          <span className="inline-block bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-1 text-sm font-medium text-blue-200 mb-4" data-id="element-1653" data-mp="1svl1qm2afwrr">
            Devenir Employeur Partenaire
          </span>
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-1654" data-mp="107p3hcx2lwsv">
            Recrutez avec l'ADCC
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-1655" data-mp="158v03ltuq47o">
            Accédez à un vivier de talents qualifiés, formés et accompagnés pour
            répondre à vos besoins en personnel de maison, hôtellerie et
            services.
          </p>
        </div>
      </div>

      {/* Avantages du Partenariat */}
      <section className="py-20 bg-gray-50" data-id="element-1656" data-mp="9xy9k2dvy8tj">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1657" data-mp="9wn1vrhbkgx5">
          <div className="text-center mb-12" data-id="element-1658" data-mp="4zd49ojs0yy8">
            <span className="text-[#1E88E5] font-semibold tracking-wide uppercase text-sm" data-id="element-1659" data-mp="50o8fph4w8pv">
              Pourquoi Recruter via l'ADCC
            </span>
            <h2 className="text-3xl font-bold text-gray-900 mt-2 mb-4" data-id="element-1660" data-mp="3rcv95l7dvzp3">
              Les avantages d'un partenariat avec l'ADCC
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-1661" data-mp="3n9yjxbnc95c6">
              Des compétences avérées, des emplois dignes, un accompagnement sur
              mesure.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1662" data-mp="3dfygde7pg85k">
            {[{
            icon: Briefcase,
            title: 'Personnels Qualifiés et Certifiés',
            desc: 'Accédez à des profils formés professionnellement avec certification reconnue. Compétences techniques et relationnelles validées.'
          }, {
            icon: Shield,
            title: 'Cadre Éthique et Transparent',
            desc: "Recrutement dans le respect des droits, conditions claires, contrats formalisés. Sensibilisation aux bonnes pratiques d'emploi."
          }, {
            icon: Users,
            title: 'Accompagnement Personnalisé',
            desc: 'Matching précis selon vos besoins, préparation du personnel avant placement, intégration facilitée.'
          }, {
            icon: TrendingUp,
            title: 'Suivi Post-Placement',
            desc: 'Accompagnement continu après recrutement, médiation en cas de besoin, garantie de durabilité de la relation professionnelle.'
          }].map((benefit, index) => <Card key={index} className="bg-white" data-id="element-1663" data-mp="czt5uvldqlyg" data-mpi={index}>
                <CardContent className="p-8 flex gap-6" data-id="element-1664" data-mp="h0uxaq921tpv">
                  <div className="flex-shrink-0" data-id="element-1665" data-mp="h2ftekb0pkpu">
                    <div className="w-14 h-14 bg-blue-50 rounded-xl flex items-center justify-center" data-id="element-1666" data-mp="3uiqbozfbimk3">
                      <benefit.icon className="w-7 h-7 text-[#1E88E5]" data-id="element-1667" data-mp="3pjnge6p53upb" />
                    </div>
                  </div>
                  <div data-id="element-1668" data-mp="7eaiyrqnozg1">
                    <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-1669" data-mp="7amq7ut1ch2d">
                      {benefit.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed" data-id="element-1670" data-mp="hadhzoq7ohyr">
                      {benefit.desc}
                    </p>
                  </div>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </section>

      {/* Processus */}
      <section className="py-20 bg-white" data-id="element-1671" data-mp="m25e0es4zfwa">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1672" data-mp="m2f4e3h3fp2i">
          <div className="text-center mb-16" data-id="element-1673" data-mp="1014x76wvr2l2">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-1674" data-mp="101xyhsd2kzvt">
              Comment ça marche ?
            </h2>
            <p className="text-xl text-gray-600" data-id="element-1675" data-mp="v0qrhvir44q7">
              Un processus simple et transparent pour un recrutement réussi.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 relative" data-id="element-1676" data-mp="3swy7cfes0984">
            {/* Ligne de connexion (desktop) */}
            <div className="hidden md:block absolute top-8 left-12 right-12 h-0.5 bg-gray-200 z-0" data-id="element-1677" data-mp="1nr0k8roffhs"></div>

            {[{
            step: '1',
            title: '1. Expression du besoin',
            desc: 'Vous remplissez le formulaire détaillant vos attentes et le profil recherché.'
          }, {
            step: '2',
            title: '2. Sélection',
            desc: 'Nous identifions les candidats les plus adaptés parmi nos bénéficiaires certifiés.'
          }, {
            step: '3',
            title: '3. Rencontre',
            desc: "Organisation d'entretiens avec les profils présélectionnés."
          }, {
            step: '4',
            title: '4. Intégration',
            desc: "Signature du contrat et suivi régulier de l'intégration."
          }].map((item, index) => <div key={index} className="relative z-10 text-center" data-id="element-1678" data-mp="29wp61rnu3xpk" data-mpi={index}>
                <div className="w-16 h-16 bg-[#1E88E5] text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-6 shadow-lg border-4 border-white" data-id="element-1679" data-mp="24ydwzj5d5r8e">
                  {item.step}
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-1680" data-mp="2xmru7womojiw">
                  {item.title}
                </h3>
                <p className="text-sm text-gray-600" data-id="element-1681" data-mp="2smnalxsfb8og">{item.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Formulaire */}
      <section className="py-20 bg-white" data-id="element-1682" data-mp="1h9b6rmwnyq2a">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1683" data-mp="1ha4eor7czlm0">
          <Card data-id="element-1684" data-mp="1d6y8tko5rwg2">
            <CardContent className="p-8" data-id="element-1685" data-mp="1d6eq41qop40z">
              <div className="flex items-center gap-4 mb-8 pb-6 border-b border-gray-100" data-id="element-1686" data-mp="3cby1kvk7n29s">
                <div className="p-3 bg-blue-50 rounded-full" data-id="element-1687" data-mp="3ceas3x41akyg">
                  <Handshake className="w-8 h-8 text-[#1E88E5]" data-id="element-1688" data-mp="3hbuan97rljw7" />
                </div>
                <div data-id="element-1689" data-mp="33cbbh5wxliw1">
                  <h2 className="text-xl font-bold text-gray-900" data-id="element-1690" data-mp="33d49nihtr02k">
                    Formulaire de partenariat
                  </h2>
                  <p className="text-gray-500 text-sm" data-id="element-1691" data-mp="3vzxhektmszm2">
                    Devenez employeur partenaire et recrutez des personnels
                    qualifiés
                  </p>
                </div>
              </div>

              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-1692" data-mp="3maxc6jojd7zf">
                <div data-id="element-1693" data-mp="3r98nyzye5ska">
                  <label htmlFor="partnerType" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1694" data-mp="3r8p1r71pki0g">
                    Type de partenaire *
                  </label>
                  <select id="partnerType" name="partnerType" required className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border bg-white" data-id="element-1695" data-mp="nkx5b0ase1jz">
                    <option value="" data-id="element-1696" data-mp="16nfj20cpdv6u">Sélectionnez...</option>
                    <option value="famille" data-id="element-1697" data-mp="11pxkn3wbayd3">Famille (particulier)</option>
                    <option value="entreprise" data-id="element-1698" data-mp="11rqoycjgd6hx">Entreprise</option>
                    <option value="institution" data-id="element-1699" data-mp="e0ush241xn4c">Institution / ONG</option>
                  </select>
                </div>

                <div data-id="element-1700" data-mp="a0ay26av4xlw">
                  <label htmlFor="orgName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1701" data-mp="ny96yw6f01u0">
                    Nom de l'organisation / Famille *
                  </label>
                  <input type="text" id="orgName" name="orgName" required className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border" placeholder="Ex: Hôtel Azalaï ou Famille Dupont" data-id="element-1702" data-mp="1zcd245oqnw0n" />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1703" data-mp="2skbzdt74apc">
                  <div data-id="element-1704" data-mp="3u06kpkurv3d2">
                    <label htmlFor="responsibleName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1705" data-mp="3tyvjnsspo9pn">
                      Nom du contact *
                    </label>
                    <input type="text" id="responsibleName" name="responsibleName" required className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border" placeholder="Votre nom" data-id="element-1706" data-mp="3l1biejuumdf1" />
                  </div>
                  <div data-id="element-1707" data-mp="197v27jaatm7f">
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1708" data-mp="1hqyastqh02sj">
                      Téléphone *
                    </label>
                    <input type="tel" id="phone" name="phone" required className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border" placeholder="+229..." data-id="element-1709" data-mp="1qk1on3512hnp" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1710" data-mp="17rhcixdjsr6l">
                  <div data-id="element-1711" data-mp="1cs4yh4mx6hty">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1712" data-mp="1csn60xf18ih6">
                      Email *
                    </label>
                    <input type="email" id="email" name="email" required className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border" placeholder="votre@email.com" data-id="element-1713" data-mp="2o4xoob02ay7w" />
                  </div>
                  <div data-id="element-1714" data-mp="23i96iz178m5y">
                    <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1715" data-mp="23fvez05q9s35">
                      Ville / Quartier *
                    </label>
                    <input type="text" id="address" name="address" required className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border" placeholder="Ex: Cotonou, Haie Vive" data-id="element-1716" data-mp="1pi6sxozxcewi" />
                  </div>
                </div>

                <div data-id="element-1717" data-mp="33p4l24ykzxjz">
                  <label htmlFor="needs" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1718" data-mp="33ol9r73fs7ex">
                    Vos besoins en recrutement *
                  </label>
                  <textarea id="needs" name="needs" required rows={4} className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border" placeholder="Quels types de profils recherchez-vous ? (Cuisinier, Nounou, Réceptionniste...)" data-id="element-1719" data-mp="2yqjtsv1b4o7o"></textarea>
                </div>

                <Button type="submit" className="w-full text-lg py-6" disabled={isLoading} data-id="element-1720" data-mp="3hfq4pvvv0bix">
                  {isLoading ? 'Envoi en cours...' : 'Envoyer la demande'}
                </Button>
              </form>
            </CardContent>
          </Card>
        </div>
      </section>
    </Layout>;
}